import * as angular from 'angular';
import * as _ from 'lodash';

import { ISeriesBuilder, ISeriesBuilderArguments } from './ISeriesBuilder';
import { SeriesMappingResult } from './SeriesMappingResult';
import { mapConfiguration } from '../../common/helpers';
import { guidEmpty } from '../../common/';
import { ISeriesService } from './';
import { SeriesConfiguration } from '../../widgets';

export interface IPivotTableService extends ISeriesBuilder {
}

export class PivotTableService implements IPivotTableService {
    static serviceId = 'pivotTableService';

    static $inject = ['$q', 'seriesService'];
    constructor(
        private _$q: angular.IQService,
        private _seriesService: ISeriesService
    ) {
    }

    buildSeriesFromViewModels(args: ISeriesBuilderArguments): angular.IPromise<SeriesMappingResult<any>> {
        const { configuration, viewModels, map, errors } = args;
        const seriesConfig: any[] = configuration.series.map(d => d);
        const hasRowSeries = configuration.rowSeries && !!configuration.rowSeries.guid && configuration.rowSeries.guid !== guidEmpty;
        if (hasRowSeries) {
            seriesConfig.push(configuration.rowSeries);
        }
        const nameConfiguration = configuration.nameConfiguration;
        const mapped = mapConfiguration(seriesConfig, viewModels, map, errors);
        const series = mapped.series
            .filter(s => !s.missing)
            .map(s => {
                const vm = s.viewModel;
                const sc = new SeriesConfiguration(s.configuration.guid, '', '');
                const name = this._seriesService.getName(sc, vm, nameConfiguration);
                return this._seriesService.createSeries(sc, name, vm);
            });
        return this._$q.when({
            error: mapped.error,
            series: _.sortBy(series, s => s.sortOrder),
            map
        });
    }

}